import { Component, OnInit, OnChanges, Input, Inject } from '@angular/core';
import { forkJoin } from "rxjs/observable/forkJoin";

import { ActivatedRoute } from '@angular/router'

import { UtilisateurService } from '../../services/utilisateur.service';
import { DroitService } from '../../services/droit.service';

import { BaseComponent } from '../../interfaces/basecomponent';

/**
 * Composant de gestion d'un utilisateur pour un fournisseur
 * @extends BaseComponent
 * @implements OnInit, OnChanges
 */
@Component({
  selector: 'app-utilisateur-par-fournisseur',
  templateUrl: './utilisateur-par-fournisseur.component.html',
  styleUrls: ['./utilisateur-par-fournisseur.component.scss']
})
export class UtilisateurParFournisseurComponent extends BaseComponent implements OnInit, OnChanges {
    @Input() codeFournisseur: string = '';
    @Input() idUtilisateur: number = 0;

    login: string = '';
    listeDroits: any[] = [];
    listeRoles: any[] = [];
    liste: any[] = [];

    /**
     * Constructeur
     * @param droitService
     * @param utilisateurService
     * @param route
     */
    constructor(@Inject(DroitService) private droitService: DroitService, @Inject(UtilisateurService) private utilisateurService: UtilisateurService, private route: ActivatedRoute) { super(); }

    /**
     * Initialisation du composant
     */
    ngOnInit() {
    }

    /**
     * Changements
     */
    ngOnChanges() {
        if (this.codeFournisseur && this.idUtilisateur) {
            // Obtenir l'utilisateur
            let utilisateur = this.utilisateurService.obtenirUtilisateur(this.idUtilisateur).subscribe((retour: any) => {
                if (retour && retour.Result && retour.Result.Login) {
                    // R�cup�ration du login
                    this.login = retour.Result.Login;
                    // Obtenir les donn�es
                    this.obtenirDonnees();
                }
            });
        }
    }

    /**
     * Enregistrer les droits de l'utilisateur pour un fournisseur
     */
    public enregistrer() {

        // R�cup�ration des r�les actifs
        let roles = [];
        this.liste.forEach((item) => {
            if (item.Actif) {
                roles.push(item.Code);
            }
        });

        // Enregistrement des r�les
        this.droitService.assignerDroitsFournisseurUtilisateur(this.codeFournisseur, this.login, roles).subscribe();
    }

    /**
     * Obtenir les donn�es (droits de l'utilisateur, r�les)
     */
    private obtenirDonnees() {
        this.liste = [];

        // Requ�te liste les droits de l'utilisateur
        let reqDroits = this.droitService.listerDroitsUtilisateur(this.login, this.codeFournisseur);

        // Requ�te liste les r�les du fournisseur
        let reqRoles = this.droitService.listerRolesFournisseur(this.codeFournisseur);

        // Attente des requ�tes
        forkJoin([reqDroits, reqRoles]).subscribe(([retourDroits, retourRoles]: any[]) => {
            // R�cup�re la liste des droits de l'utilisateur
            if (retourDroits && retourDroits.Result) {
                this.listeDroits = (retourDroits.Result as any[]);
            }

            // R�cup�re la liste des r�les
            if (retourRoles && retourRoles.Result) {
                this.listeRoles = (retourRoles.Result as any[]);
            }

            // Cr�ation de la liste en fonctions de r�les et des droits de l'utilisateur'
            this.listeRoles.forEach((role) => {
                let possedeDroit = this.listeDroits.find((droit) => {
                    return droit.CodeRole == role.Code;
                });
                this.liste.push({ Libelle: role.Libelle, Code: role.Code, Actif: possedeDroit != null })
            });
        });
    }
}
